<ion-header>

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (click)="openModalAddSite()">
                <ion-icon slot="icon-only" name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar animated debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
    </ion-toolbar>

</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchSite($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Sites...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-list>
        <ion-item *ngFor="let site of siteList | filterSite: queryText" (click)="modalController.dismiss(site)">
            <ion-label>
                <h4><strong> {{ site.name }} </strong></h4>
                <p> {{ site.add1 }} </p>
                <p> {{ site.add2 }} </p>
                <p> {{ site.add3 }} </p>
                <p> {{ site.add4 }} </p>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>
